import '../i18n';

import AuthorAttributionsBody from '../components/AuthorAttributionsBody';
import { BackToTop } from 'material-ui-back-to-top';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import NavbarWhite from '../components/navbar/NavbarWhite';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AuthorAttributions = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>{t('seo.page.authorAtributions.title')}</title>
      </Helmet>
      <BackToTop size="small" buttonPosition={{ bottom: 20, right: 20 }} />
      <NavbarWhite />
      <AuthorAttributionsBody />
      <Footer />
    </div>
  );
};

export default AuthorAttributions;
